import React from "react";
import { Header, Flag, Countries, useColorTokens } from "@tvg/design-system";
import { TitleContainer, FlagContainer } from "./styled-components";

interface RaceTitleProps {
  isLiveTv?: boolean;
  country?: string;
  trackName?: string;
  raceNumber?: string;
  showLegNumber?: boolean;
  legNumber?: number;
}

export const RaceTitle = ({
  isLiveTv,
  country,
  trackName,
  raceNumber,
  showLegNumber,
  legNumber
}: RaceTitleProps) => {
  const colorTokens = useColorTokens();

  return (
    <TitleContainer isLiveTv={isLiveTv}>
      {isLiveTv && country && (
        <FlagContainer>
          <Flag
            qaLabel="race-country-flag"
            size="l"
            country={country as Countries}
          />
        </FlagContainer>
      )}
      <Header
        tag="h2"
        color={colorTokens.content.default}
        fontFamily="medium"
        qaLabel={isLiveTv ? "track-name-and-number" : "race-number-header"}
      >
        {isLiveTv
          ? `${trackName} R${raceNumber}`
          : `${
              showLegNumber
                ? `Leg ${legNumber} - Race ${raceNumber}`
                : `Race ${raceNumber}`
            }`}
      </Header>
    </TitleContainer>
  );
};

export default RaceTitle;
